import { FieldProps } from "../renderFieldInput";
import { Wysiwyg } from "../../wysiwyg/Wysiwyg";
import { TextInputField } from "./TextInputField";


interface WysiwygInputFieldProps extends FieldProps {}

export function WysiwygInputField({ field, value, entityForm, options, extraOptions }: WysiwygInputFieldProps) {
    const isFilterView = extraOptions?.field?.startsWith("filters.");

    if (isFilterView) {
        return <TextInputField field={field} value={value} entityForm={entityForm} options={options} extraOptions={extraOptions} />;
    }

    return <Wysiwyg entityForm={entityForm} initialValue={value} isDisabled={options?.disabled} field={field} size={extraOptions?.style?.height} toolbarItems={extraOptions?.style?.toolbarItems} />;
}
